import { TUpdateClientLoginParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const updateClientLogin = async (params: TUpdateClientLoginParams) => {
  const { clientId, nextLogin } = params;

  await m8API.admin.setUserEmail({ idUser: clientId, newEmail: nextLogin });
};
